import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m9.55 15.88 8.802-8.801a.508.508 0 0 1 .344-.156.47.47 0 0 1 .363.156.5.5 0 0 1 .166.356.499.499 0 0 1-.166.357l-8.944 8.95a.776.776 0 0 1-.565.242.776.776 0 0 1-.565-.242l-4.05-4.05a.484.484 0 0 1 .006-.713.499.499 0 0 1 .356-.166c.128 0 .247.055.357.166L9.55 15.88Z" }, null, -1)
  ]))]))
}
export default { render: render }